/**
 * Touchpoints for which the Standard upgrade modal has tailored header + content
 * (see getTouchpointHeader / getTouchpointContent). These mirror the dedicated
 * cases the Upflow V2 experiment treatment modal supported. Any touchpoint NOT in
 * this list intentionally falls through to the direct-to-Commerce path rather than
 * opening the modal with generic default content.
 */
export const SUPPORTED_TOUCHPOINTS = [
	'shareAndRestrictDialogUpsell',
	'individualSpacePermission',
	'adminGlobalPermissions',
	'adminSpacePermissions',
	'publicLinksExportUpsell',
] as const;

export type SupportedTouchpoint = (typeof SUPPORTED_TOUCHPOINTS)[number];
